require('./GridForm.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText } = require('core/i18n').i18n;

class GridForm extends React.Component {

    buildRow(components) {
        const rowItems = components.map(element => this.buildRowItem(element, components.length));
        return <div className="form-item row"> { rowItems } </div>;
    }

    buildRowItem(component, rowLength) {
        //If size is not set in the component, it assings a size
        const { buildComponent } = this.props;
        const componentSize = `col-xs-${component.size || Math.floor(12 / rowLength)}`;
        const content = buildComponent(component);
        return (
            <div className={componentSize} key={component.id}>
                {content}
            </div>
        );
    }

    buildGridForm(component) {
        return component.grid.map(element => this.buildRow(element));
    }

    render() {
        const {
            isVisible,
            component,
        } = this.props;
        let content;
        const gridContents = this.buildGridForm(component);

        if (isVisible) {
            content = (
                <div className="grid-form">
                    <h4 className="grid-form__header">
                        <FormattedText value={component.label} />
                    </h4>
                    { gridContents }
                </div>
            )
        }
        return content;
    }
}

GridForm.propTypes = {
    buildComponent: PropTypes.func.isRequired,
    component: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired
};

module.exports = GridForm;

